(function () {
  "use strict";

  if (window.kachingRequiredSelectionGuardLoaded) return;

  window.kachingRequiredSelectionGuardLoaded = true;

  document.addEventListener(
    "click",
    function (event) {
      const selectedBarMain = event.target.closest?.(
        ".kaching-bundles__bar--selected .kaching-bundles__bar-main",
      );

      if (!selectedBarMain) return;

      const nestedControl = event.target.closest(
        'select, button, a, input, textarea, [role="button"], [role="checkbox"]',
      );

      if (nestedControl && nestedControl !== selectedBarMain) return;

      event.preventDefault();
      event.stopImmediatePropagation();
    },
    true,
  );
})();
